module.exports = __webpack_public_path__ + "static/media/open-auth-mockup.f5b981a5.jpg";